<template>
  <h3>Page not found!</h3>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>
